import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { useMediaQueries } from '@nxtpeople/nxt-styles';
import { ColorTheme } from '@nxtpeople/nxt-vue-library';
import dayjs from 'dayjs';
import { computed, ref, watch } from 'vue';
import { UserInfo } from '../collections/api/user/user-info.interface';
import { clearAllCache } from '../helpers/cache.helper';
import { useWebSockets } from '../hooks/useWebSockets';
import { useStore } from './useStore';
const { md, xs } = useMediaQueries();

export function useApp() {
   const { state, dispatch } = useStore();

   //#region Global Data
   const loading = ref(false);
   async function fetchGlobalData() {
      loading.value = true;
      try {
         await Promise.allSettled([dispatch('performanceCode/getAll'), dispatch('language/get'), dispatch('slotState/get')]);
      } finally {
         loading.value = false;
      }
   }
   //#endregion

   //#region Keycloak
   const { isAuthenticated } = useKeycloak();

   async function handleAuthChange(isAuthenticated: boolean) {
      if (isAuthenticated) {
         return await fetchGlobalData();
      }
   }
   watch(isAuthenticated, handleAuthChange, { immediate: true });
   //#endregion

   //#region User Info
   const userInfo = computed(() => state.user?.user_info);
   const { locale } = useI18n();

   function handleLocaleChange(newLocale: string) {
      if (newLocale) {
         dayjs.locale(newLocale);
         dayjs.updateLocale(newLocale, { weekStart: 1 });
         document.documentElement.lang = newLocale?.toLowerCase();
      }
   }

   function handleUserChange(userInfo?: UserInfo, oldUserInfo?: UserInfo) {
      if (xs.value && localStorage.getItem('accepted-cookies') === 'true') {
         identifySentryUser(userInfo);
      }

      if (userInfo) {
         if (oldUserInfo) clearAllCache();
         locale.value = userInfo.language.key.toLowerCase();

         dayjs.locale(locale.value);
         dayjs.updateLocale(locale.value, { weekStart: 1 });
      }
   }

   watch(userInfo, handleUserChange, { immediate: true });
   watch(locale, handleLocaleChange, { immediate: true });
   //#endregion

   //#region websockets
   const { registerWebSockets, unregisterEcho } = useWebSockets();
   watch(userInfo, registerWebSockets, { immediate: true });
   //#endregion

   return { loading };
}
